import { InjectionToken } from '@angular/core';

export const APPLICATION_INSIGHTS_INSTRUMENTATION_TOKEN = new InjectionToken<string>('applicationInsightsInstrumentationKey');
